import type { Validator } from '../Validator'
import { regexValidator } from './regexValidator'

export const emailValidator = (
    options: Validator.options
): Validator.validatorSingle<number | string | undefined, unknown> =>
    regexValidator({
        invalidMessage: 'E-mail non valida',
        ...options,
        regex: new RegExp(
            "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
        ),
    })
